import Lenis from '@studio-freight/lenis'

const lenis = new Lenis({
    wrapper: document.body,
    duration: 2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'both',
    wheelMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
    smoothWheel: true
})

lenis.on('scroll', (e) => { });

function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

export const lenisInstance = lenis;